import React, {FC} from 'react';
import {IGetClientById} from 'store/models/clients';
import dayjs from 'dayjs';
import styles from '../ClientsInformation.module.scss';

interface Props {
  clientInfo: IGetClientById | undefined;
}

const ActivityLogTab: FC<Props> = (props) => {
  return (
    <div className={styles.clientActivityLogTab}>
      {props?.clientInfo?.audit?.creating ? (
        <div>
          <span className={styles.auditTitle}>Created at</span>
          <span className={styles.auditText}>
            {dayjs(props?.clientInfo?.audit.creating?.actionDateTime).format(
              'DD.MM.YYYY HH:mm:ss',
            ) || null}
          </span>
          <span className={styles.auditText}>
            {props?.clientInfo?.audit.creating?.userEmail}
          </span>
          <span className={styles.auditText}>
            {props?.clientInfo?.audit.creating?.userFullName}
          </span>
        </div>
      ) : null}
      {props?.clientInfo?.audit?.updating ? (
        <div>
          <span className={styles.auditTitle}>Updated at</span>
          <span className={styles.auditText}>
            {dayjs(props?.clientInfo?.audit.updating?.actionDateTime).format(
              'DD.MM.YYYY HH:mm:ss',
            ) || null}
          </span>
          <span className={styles.auditText}>
            {props?.clientInfo?.audit.updating?.userEmail}
          </span>
          <span className={styles.auditText}>
            {props?.clientInfo?.audit.updating?.userFullName}
          </span>
        </div>
      ) : null}
      {props?.clientInfo?.audit?.deleting ? (
        <div>
          <span className={styles.auditTitle}>Deleted at</span>
          <span className={styles.auditText}>
            {dayjs(props?.clientInfo?.audit.deleting?.actionDateTime).format(
              'DD.MM.YYYY HH:mm:ss',
            ) || null}
          </span>
          <span className={styles.auditText}>
            {props?.clientInfo?.audit.deleting?.userEmail}
          </span>
          <span className={styles.auditText}>
            {props?.clientInfo?.audit.deleting?.userFullName}
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default ActivityLogTab;
